// extracted by mini-css-extract-plugin
module.exports = {"root":"SmsMessageContainer_root_1_BbS"};